<template>
  <div id="jpapp">
    <Filters
      @change="onFiltersChanged"
      ref="filterComponent"
      :visible="filtersVisible"
      :filter-options="filterOptions"
      :initial-filter="initialFilter"
    />
    <div class="container">
      <Info
        v-if="!loading"
        :filters="filters"
        @clear="onClear"
        :visible="!filtersVisible"
        :job-count="jobPostings.length"
        @remove-filter="onRemoveFilter"
        @show-filters="onShowFilters"
      ></Info>
      <Results :postings="jobPostings" :visible="!filtersVisible" :loading="loading"/>
    </div>
  </div>
</template>

<script>
import Filters from "./components/Filters.vue";
import Results from "./components/Results.vue";
import Info from "./components/Info.vue";
import DB from "./services/datalayer.js";
import moment from "moment";

export default {
  name: "app",
  components: {
    Filters,
    Results,
    Info
  },
  data() {
    return {
      filters: null,
      jobPostings: [],
      filtersVisible: true,
      loading: false,
      filterOptions: {},
      initialFilter:""
    };
  },
  mounted() {
    var locale = window.navigator.userLanguage || window.navigator.language;
    moment.locale(locale);
    DB.init();

    var filter = "";
    var params = window.location.href.substring(window.location.href.indexOf("?") + 1);
    if (params.length > 0) {
        params.split("&").forEach(function (item) {
            var pair = item.split("=");
            if (pair.length == 2) {
                var key = pair[0].toLowerCase();
                if (key == "country") {
                    if (filter) filter+="&";
                    filter += "country=" + pair[1];
                }
                else if (key == "region") {
                    if (filter) filter+="&";
                    filter += "region=" + pair[1];
                }
                else if (key == "family") {
                    if (filter) filter+="&";
                    filter += "family=" + pair[1];
                }
                else if (key == "type") {
                    if (filter) filter+="&";
                    filter += "type=" + pair[1];
                }
            }
        });
    }
    this.loadPostings(filter);
  },
  methods: {
    loadPostings(initialFilter) {
      this.initialFilter = initialFilter;
      this.loading = true;
      DB.getJobPostings(this.filters, initialFilter)
        .then(res => {
          this.jobPostings = res.data;
          this.filterOptions = DB.getFilterOptions(this.jobPostings);
          if (initialFilter) {
            this.filters = DB.getInitialFilterTags(initialFilter, this.filterOptions);
            this.filtersVisible = false;
          }
          this.loading = false;
        })
        .catch(err => {
          this.loading = false;
          alert(err);
        });
    },
    onFiltersChanged(flt) {
      this.filters = flt;
      this.jobPostings = [];
      this.loadPostings();
      this.filtersVisible = false;
    },
    onClear() {
      this.$refs.filterComponent.clear();
    },
    onRemoveFilter (name) {
      this.$refs.filterComponent.removeFilter(name);
    },
    onShowFilters () {
      this.filtersVisible = true;
    }
  }
};
</script>

<style>
#jpapp {
  font-family: "Gotham SSm A", Arial, Helvetica, sans-serif;
  display: flex;
  flex-direction: row;
}

#jpapp * {
  box-sizing: border-box;
}

#jpapp .container {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  width: 100%;
}
</style>
